var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRtCheckIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.087 6.56841C14.8601 7.38179 14.8601 8.61756 14.087 9.43094C12.7832 10.8028 10.5438 12.6663 8.00016 12.6663C5.45649 12.6663 3.21716 10.8028 1.9133 9.43094C1.14023 8.61756 1.14023 7.38179 1.9133 6.56841C3.21716 5.19656 5.45649 3.33301 8.00016 3.33301C10.5438 3.33301 12.7832 5.19656 14.087 6.56841Z",
    stroke: "#181D27"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    stroke: "#181D27"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRtCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RT_check_icon.27116d38bed7d6b493c7e58e34c7faa7.svg";